import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.94815 12.0001C7.94815 11.4804 8.0344 10.9822 8.18853 10.5149L5.49228 8.45605C4.96678 9.52293 4.67078 10.7252 4.67078 12.0001C4.67078 13.2739 4.96653 14.4753 5.49115 15.5416L8.1859 13.4787C8.03328 13.0136 7.94815 12.5172 7.94815 12.0001Z",
      fill: "#FBBC05"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12.6821 7.27275C13.811 7.27275 14.8306 7.67275 15.6317 8.32725L17.9622 6C16.5421 4.76363 14.7214 4 12.6821 4C9.51612 4 6.79512 5.8105 5.49225 8.456L8.18837 10.5149C8.80962 8.62912 10.5805 7.27275 12.6821 7.27275Z",
      fill: "#EA4335"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12.6821 16.7272C10.5806 16.7272 8.80975 15.3709 8.1885 13.4851L5.49225 15.5436C6.79512 18.1895 9.51612 20 12.6821 20C14.6361 20 16.5017 19.3061 17.9019 18.0061L15.3426 16.0276C14.6205 16.4825 13.7111 16.7272 12.6821 16.7272Z",
      fill: "#34A853"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M20.3293 12C20.3293 11.5273 20.2564 11.0182 20.1471 10.5455H12.6821V13.6364H16.9791C16.7643 14.6903 16.1795 15.5004 15.3426 16.0277L17.9019 18.0062C19.3726 16.6412 20.3293 14.6077 20.3293 12Z",
      fill: "#4285F4"
    }, null, -1)
  ])))
}
export default { render: render }